// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('board_menu_vis');

// eslint-disable-next-line @trello/no-module-logic
export const BoardMenuVisTemplate = t.renderable(function ({
  current,
  isNewBoard,
  canChange,
  mustChange,
  hasSuperAdmins,
  hasOrg,
  orgName,
  privateRestricted,
  orgRestricted,
  enterpriseRestricted,
  publicRestricted,
  hasEnterprise,
  enterpriseName,
  isTemplate,
  isPaidOrg,
  isTeamlessOwnedBoard,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) {
  if (mustChange) {
    if (orgName) {
      t.p('.quiet', () => t.format('illegal org visibility', { orgName }));
    } else if (isTeamlessOwnedBoard && enterpriseName) {
      t.p('.quiet', () =>
        t.format('illegal teamless visibility', { enterpriseName }),
      );
    }
  }
  const orgLevel =
    hasEnterprise && enterpriseName && !isTeamlessOwnedBoard
      ? 'with enterprise'
      : hasSuperAdmins
      ? 'with super admins'
      : hasOrg
      ? 'with organization'
      : 'without organization';

  const permissionLevels = {
    private: {
      iconClass: 'icon-private',
      restricted: privateRestricted,
      invalid: !isPaidOrg && isTemplate,
    },
    org: {
      iconClass: 'icon-organization',
      restricted: orgRestricted,
      invalid: isNewBoard && !hasOrg,
    },
    enterprise: {
      iconClass: 'icon-enterprise',
      restricted: hasEnterprise && enterpriseRestricted,
      noEnterprise: !hasEnterprise,
      invalid: isNewBoard && !hasOrg,
    },
    public: {
      iconClass: 'icon-public',
      restricted: publicRestricted,
    },
  };

  if (isTeamlessOwnedBoard) {
    // @ts-expect-error TS(2790): The operand of a 'delete' operator must be optiona... Remove this comment to see the full error message
    delete permissionLevels.org;
    // @ts-expect-error TS(2790): The operand of a 'delete' operator must be optiona... Remove this comment to see the full error message
    delete permissionLevels.enterprise;
  }

  return (() => {
    const result = [];
    for (const permissionLevel in permissionLevels) {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      const { restricted, invalid, iconClass, noEnterprise } = permissionLevels[
        permissionLevel
      ];
      result.push(
        t.li(function () {
          const disabled = restricted || invalid || !canChange || noEnterprise;
          return t.a(
            '.js-select',
            {
              class: t.classify({ disabled: disabled }),
              href: '#',
              name: permissionLevel,
            },
            function () {
              t.span('.icon-sm.vis-icon', { class: iconClass }, function () {});
              t.check(current === permissionLevel, permissionLevel);
              return t.span('.sub-name', function () {
                const args =
                  enterpriseName && !isTeamlessOwnedBoard
                    ? { enterpriseName, orgName }
                    : orgName
                    ? { orgName }
                    : {};

                const templateSubtext = isTemplate ? 'is template ' : '';
                t.format(
                  [
                    'permission subtext',
                    `${templateSubtext}${orgLevel}`,
                    permissionLevel,
                  ],
                  args,
                );

                if (canChange && restricted) {
                  t.raw(' ');
                  return t.span('.error', function () {
                    if (isNewBoard) {
                      return t.format([
                        'illegal visibility',
                        hasOrg ? 'create' : 'create teamless',
                      ]);
                    } else {
                      return t.format([
                        'illegal visibility',
                        hasOrg ? 'change' : 'change teamless',
                      ]);
                    }
                  });
                }
              });
            },
          );
        }),
      );
    }
    return result;
  })();
});
